import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import ListItem from '@mui/material/ListItem';

const Component: React.FC = () => {
    return (
        <ListItem className="groups__item" component="li">
            <Skeleton className="groups__skeleton" />
        </ListItem>
    );
};

const ListSkeletonComponent = React.memo(Component);

export default ListSkeletonComponent;
